import { Controller } from "stimulus"
import { hexToRgba } from "../utils/helpers"
import Rails from "@rails/ujs";

export default class extends Controller {
  connect() {
    new ClipboardJS('#copy-to-clipboard');
    Prism.highlightAll();
  }
}